export default {
  signIn: "/signin",
  signUp: "/signup",
  resetPassword: "/reset-password",
  setPassword: "/set-password/:token",

  offers: "/offers",
  offersAdd: "/offers/add",
  offersEdit: "/offers/:uid",

  applications: "/applications",
  applicationsSingle: "/applications/:uid",

  settings: "/settings"
};



// WEBPACK FOOTER //
// ./src/routes.js